module.exports = __webpack_public_path__ + "img/forcepoint.85854ed7.png";